export const menu = {
  home: "Home",
  corporateIdentity: "Corporate Identity",
  pages: "Pages",
  aboutUs: "About Us",
  faq: "FAQ",
  error404: "Error 404",
  services: "Services",
  maritimeLaw: "Maritime Law",
  taxLaw: "Tax Law",
  customsLaw: "Customs Law",
  commercialLaw: "Commercial Law",
  insurance: "Insurance",
  administrativeProcesses: "Administrative Processes",
  stsOperations: "STS Operations",
  contact: "Contact",
  language: "Language",
  spanish: "Spanish",
  english: "English",
  chinese: "Chinese",
  contactUs: "Contact Us",
  ofac: "OFAC"
};
